import { Mail, Users, FileText, BarChart } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { motion } from "framer-motion";

export const ServicesGrid = () => {
  const services = [
    {
      icon: <Mail className="h-8 w-8 text-blue-500" />,
      title: "Inbound Lead Generation",
      description: "AI-powered nurturing campaigns and personalized email flows that identify and engage high-quality leads based on behavior and data."
    },
    {
      icon: <Users className="h-8 w-8 text-blue-500" />,
      title: "Outbound Lead Generation",
      description: "Leverage AI agents for cold outreach optimization and predictive analytics to target prospects effectively and maximize conversion rates."
    },
    {
      icon: <FileText className="h-8 w-8 text-blue-500" />,
      title: "Lead Magnets",
      description: "Create compelling AI-optimized content including ebooks, webinars, and whitepapers that resonate with your target audience."
    },
    {
      icon: <BarChart className="h-8 w-8 text-blue-500" />,
      title: "Sales Analytics",
      description: "Comprehensive AI-powered dashboards providing real-time insights into team performance and conversion metrics."
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-7xl mx-auto px-4">
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Comprehensive Lead Generation Solutions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Transform your lead generation and sales processes with our AI-powered solutions
          </p>
        </motion.div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Card className="h-full hover:shadow-xl transition-shadow duration-300">
                <CardContent className="p-6">
                  <div className="mb-6">{service.icon}</div>
                  <h3 className="text-xl font-semibold mb-4 text-gray-900">
                    {service.title}
                  </h3>
                  <p className="text-gray-600">{service.description}</p>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
